import { Injectable } from '@angular/core';
import { CoursewareProgress } from '@learning/models/courseware/courseware-progress.model';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  RememberCourseWareProgressions,
  ResetCourseWareProgressions
} from './courseware-state.actions';

export class CourseWareStateModel {
  readonly progressions: CoursewareProgress[];
  readonly isLoadedSuccessfully: boolean;
}

@State<CourseWareStateModel>({
  name: AppStoreKeys.CourseWareProgress,
  defaults: {
    progressions: [],
    isLoadedSuccessfully: false
  }
})
@Injectable()
export class CourseWareState {
  @Selector()
  public static getProgressions(
    state: CourseWareStateModel
  ): CoursewareProgress[] {
    return state.progressions;
  }

  @Action(RememberCourseWareProgressions)
  rememberTraining(
    context: StateContext<CourseWareStateModel>,
    action: RememberCourseWareProgressions
  ): void {
    context.patchState({
      progressions: action.payload,
      isLoadedSuccessfully: action.isLoadedSuccessfully
    });
  }

  @Action(ResetCourseWareProgressions)
  resetTraining(context: StateContext<CourseWareStateModel>): void {
    context.setState({
      progressions: [],
      isLoadedSuccessfully: false
    });
  }
}
